import * as React from 'react'
import { type LucideIcon } from 'lucide-react'
import { cn } from '../lib/utils'

/**
 * Chip — канон ФИЛЬТРОВ в студии (view-toggle списка: Все/Избранные, разделы каталога).
 * Только фильтрация — НЕ выбор фиксируемой настройки. Для выбора значения, которое
 * сохраняется (Доступ, Категория): сегмент-контрол (2–4 взаимоисключ.) или
 * <RadioCardGroup> (много вариантов, сеткой).
 * НЕ наложение: выбранный = нейтральный залив (bg-foreground/10 + border-foreground/20 + foreground),
 * бренд по умолчанию НЕ тратится. Невыбранный = прозрачный, текст muted, ховер foreground/5.
 * Проп `brand` — брендовый акцент для выбранного (сплошной bg-brand + text-brand-foreground),
 * когда чип должен подсвечивать активный выбор фирменным цветом.
 */
export interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean
  icon?: LucideIcon
  count?: number
  /** Брендовый акцент для активного состояния вместо нейтрального залива. */
  brand?: boolean
}

export const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  ({ active, icon: Icon, count, brand, className, children, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      data-active={active}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-[13px] font-medium border whitespace-nowrap transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        active
          ? brand
            ? 'bg-brand border-brand text-brand-foreground hover:bg-brand-hover'
            : 'bg-foreground/10 border-foreground/20 text-foreground'
          : 'border-transparent text-muted-foreground hover:bg-foreground/5 hover:text-foreground',
        className,
      )}
      {...props}
    >
      {Icon && <Icon className="w-3.5 h-3.5" />}
      {children}
      {count !== undefined && (
        <span
          className={cn(
            'ml-1',
            active
              ? brand
                ? 'text-brand-foreground/70'
                : 'text-foreground/50'
              : 'text-muted-foreground/60',
          )}
        >
          {count}
        </span>
      )}
    </button>
  ),
)
Chip.displayName = 'Chip'
